import { styled } from 'styled-components';

export const AdditionalInfoContainer = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 24px;
`